import { render } from "./ScenarioDiagram.vue?vue&type=template&id=4e2b7960"
import script from "./ScenarioDiagram.js?vue&type=script&lang=js"
export * from "./ScenarioDiagram.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__